/**
 * Fetches the current user's as a Member object.
 * @param uid Optional uid to fetch - if not provided, uses current user from vuefire
 * @returns Promise<Member | null>
 */
export const useCurrentMember = async (uid?: string): Promise<Member | null> => {
  const userId = uid ?? useCurrentUser().value?.uid
  if (!userId) {
    return null
  }

  const membersStore = useMembersStore()
  const member = await membersStore.fetchMember(userId)
  return member
}
